import { ICON_SELECTOR, IconSize } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { FlexBox } from '@ardoq/layout';

export const DecoratorWrapper = styled(FlexBox).attrs({
  gap: 'small',
  align: 'center',
})<{
  $skipIconColor?: boolean;
}>`
  ${({ $skipIconColor }) =>
    !$skipIconColor &&
    css`
      & > ${ICON_SELECTOR} {
        color: ${colors.icon};
      }
    `};
  /* when rendering descriptions with the markdown viewer, everything is wrapped in a p tag with some unnecessary margin */
  p {
    margin: 0;
  }
`;

export const DecoratorPlaceholder = styled.span`
  color: ${colors.textSubtle};
`;

export const DECORATOR_SELECTOR = DecoratorWrapper.toString();

export const getDecoratorIconSize = () => IconSize.MEDIUM;
